module.exports = __webpack_public_path__ + "6dca154fdaa55fbbc7aac113c97b6eb6.png";